import React,{useState,useEffect} from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { pathOr } from "ramda";
import Paper from '@mui/material/Paper';
import {CircularProgress} from '@material-ui/core';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import { getCalculations } from '../../../../../../common/policyCalculation';
import {getCurlCall,configureDashlet } from "../../../../../../store/actions/dashboard.actions";
import { useDispatch, useSelector } from "react-redux";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import {Typography,Link} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import useStyles, { getMuiTheme } from "./styles";
import { useTheme } from '@material-ui/core/';
import { MuiThemeProvider } from "@material-ui/core/styles";
import { toast } from "react-toastify";
import SkeletonShell from "../../../../../Skeleton";

function XirrTable({data,type,name,setValue,allTabFilter,setShowXirrVersion,showXirrVersion}) {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const [defaultType, setDefaultType ]= useState(pathOr('',['result', 'data'], data)?Object.keys(pathOr({'SP':'SP'},['result', 'data'], data))[0]: 'SP');
  const { storeStateData,storeStateLoading } = useSelector((state) => state.dashboard);
  const configureDashletLoading = useSelector((state) => state.dashboard.configureDashletLoading);
  const xirrData=pathOr([], ['xirr', 'data'], storeStateData);
  const newType=xirrData.hasOwnProperty('SP')?'SP':xirrData.hasOwnProperty('RP')?'RP':defaultType; 
  const dataTypes = {'MTD':'MTD','YTD':'YTD','1YTD':'1 Year','3YTD':'3 Years','5YTD':'5 Years','inc':'Since Inception'};

  // const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = React.useState(type===defaultType || ((newType==='SP' || newType==='RP') && type===newType)?true:false);
  const [newXIRRALL,setNewXIRRALL] = useState(type==='overall'?pathOr([],['result', 'data'], data):pathOr(pathOr([],['result', 'data',defaultType], data), [ type], xirrData));
 
  // useEffect(()=>{

  // },[expanded])

  const handleChange = (panel) => (event, isExpanded) => {
    setShowXirrVersion(panel)
    if(showXirrVersion===panel){
      setExpanded((preValue)=> preValue?false:true);
    }else{
  // setLoading(panel);
  const request= {request: {
        client_id: '$current_user->id',
        end_date: [
          'allTabFilter',
          1,
          'to_date'
        ],
        dashletType: 'xirr',
        subdashletType: panel,
        currency: [
          'allTabFilter',
          0,
          'currency'
        ]
      }};
          try {
            dispatch(getCurlCall(request,allTabFilter)).then(function (res) {
         
              if (pathOr(false, ['ok'], res)) {
                // console.log("dddddddd",panel,res.data)
               
                // setNewXIRRALL(pathOr([], ['data', 'data', panel], res))
                // setExpanded(panel);
                // setLoading(false);
              } else {
                toast('Something went wrong!');
                // setLoading(false);
           
              }
            });
          } catch (e) {
            toast("Something went wrong!");
          }
        }    
  
  

  };

  const redirectOnLink=(record,tab)=>{
    let redirectFieldsArray=[{name:'pname',value:record}]
    let redirectDestructData=[redirectFieldsArray]
    const params = {
      "configureDashlet": {
          "id": 'c5278ddb-f23b-3523-2ffc-61f140c15f43',
          "module": "HomeApp",
          "configure": "true",
          "redirected": "true",
          'type': 'custom',
          'data': {data:pathOr([], [0], redirectDestructData)},
          'currentTab': tab,
          'dashlets': []
      }

  };
  try {
      dispatch(configureDashlet(params)).then(function (res) {
          if (res.data.status === 200) {
                  toast('Dashlet Updated Successfully!')
                  setValue(6)
          } else {
              toast('Something went wrong!');

          }
      });
  } catch (e) {
      toast('Something went wrong!');
  }
  }
  const makeid=()=> {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    
    for (var i = 0; i < 5; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    
    return text;
    }
  
  const genrateTable =(rowType=[],rowPolicy=[],panel='')=>{
    return <>
     {configureDashletLoading ?<SkeletonShell layout="table" />:
    
    <TableContainer component={Paper} key={makeid()}>
    <Table size="small" aria-label="a dense table" key={makeid()}>
      <TableHead key={makeid()}>
        <TableRow className={classes.tableHeading} key={makeid()}>
        {panel!==''?<TableCell align="left"  key={makeid()}></TableCell>:null}
        {/* 03/02/2023: Removed key value inconsitency */}
          {Object.values(dataTypes).map((type)=>  <TableCell key={makeid()} className={classes.tableTh} align="left">{type}</TableCell>)}
               </TableRow>
      </TableHead>
      <TableBody key={makeid()}>
        <TableRow
          key={makeid()}
          sx={{'&:last-child td, &:last-child th': { 'border': 0 } }}
        >{Object.keys(pathOr({}, ['cagr'], rowType)).length >0?<>{panel!==''?<TableCell key={makeid()} align="left" ><strong> Overall</strong> </TableCell>:null}
          {Object.keys(dataTypes).map((type)=><TableCell key={makeid()} align="left" >
            {getCalculations('getValueInDecimalAndPercent', rowType[type])}</TableCell>)}</>:<TableCell colSpan={Object.keys(dataTypes).length+1} align="center">No Data</TableCell>}</TableRow>
        {Object.keys(rowPolicy).map((rowPNumber) => (
                  rowPNumber !== 'overall' ?
                    <TableRow
                    key={makeid()}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    // style={{display:!openSP?'none':'unset'}}
                    >
                       <TableCell key={makeid()} align="left">
                          <Link key={makeid()} onClick={()=>redirectOnLink(rowPNumber,6)} underline="none">
                          {rowPNumber}
                          </Link>
                        </TableCell>
                  {Object.keys(dataTypes).map((type)=>   <TableCell align="left" key={makeid()}>
                  {getCalculations('getValueInDecimalAndPercent', rowPolicy[rowPNumber][type])}</TableCell>)}
                  </TableRow>
                    : null
                ))}
            </TableBody>
    </Table>
  </TableContainer>}</>;
  }
  const setAccordion = (panel,name,mainRow,subRow) =>{
    // console.log(expanded,panel,name,mainRow,subRow)
    return   <Accordion expanded={type==='overall' || ((newType==='SP' || newType==='RP') && type===newType)?expanded:expanded===panel} square={true} disableGutters={true} key={makeid()} onChange={handleChange(panel)}>
       <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pl: 1,
          mt:1,
          bgcolor: 'background.paper',
          borderRadius: 1,
        }}
        key={makeid()}
      >
        <Typography key={makeid()} className={classes.cursorPointer} ><strong>{name}</strong></Typography>
        <AccordionSummary
        key={makeid()}
          expandIcon={type===showXirrVersion && storeStateLoading?<CircularProgress size={24}/>:panel!=='overall'?<ExpandMoreIcon />:null}
          aria-controls={panel+"bh-content"}
          id={panel+"bh-header"}
          classes={{content:classes.AccordionSummary}}

        >
      
        </AccordionSummary>
      </Box>
    <AccordionDetails key={makeid()} className={classes.AccordionDetails}>
      {genrateTable(mainRow,subRow,panel)}        
    </AccordionDetails>
  </Accordion>;
  }

  return (
    <MuiThemeProvider theme={getMuiTheme(theme)}>

    <div>
        {/* <Accordion expanded={true} key={makeid()} onChange={handleChange('overall')}>
        
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              pl: 1,
              bgcolor: 'background.paper',
              borderRadius: 1,
            }}
            key={makeid()}
          >
            <Typography key={makeid()} className={classes.cursorPointer} >
                <strong cursor="pointer">  Consolidated Total Portfolio</strong>
            </Typography>
            <AccordionSummary
            key={makeid()}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
              classes={{content:classes.AccordionSummary}}
            >
              
            </AccordionSummary>
          </Box>
          
          <AccordionDetails key={makeid()} className={classes.AccordionDetails}>
            {genrateTable(newXIRRALL)}
          </AccordionDetails>
        </Accordion> */}
 
 
        {setAccordion(type,name,pathOr([],['overall'],newXIRRALL),newXIRRALL)}
    </div>
    </MuiThemeProvider>
  );
}

export default React.memo(XirrTable)